import { useEffect, useState } from 'react';
import { moment } from '@hotjar/webapp/lib/moment';
import type { Site } from '@hotjar/site';
import { useHighlightsList } from '@hotjar/webapp/features/Highlights/List';
import { getRouteConfigByPath } from '@hotjar/webapp/utils/routing';
import { getRecordingPath } from '@hotjar/recordings/src/utils/getRecordingPath';
import { DEFAULT_SEGMENT } from '@hotjar/webapp/domains/segments/constant';
import type { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { useRecordingsWidgetData } from './useRecordingsWidget';

interface HighlightsSuggestions {
  isEnabled: boolean;
  highlightsLink: string;
}

export const useHighlightsSuggestions = (site: Site): HighlightsSuggestions => {
  const routeConfig = getRouteConfigByPath(window.location.pathname);
  const weeksSinceTCinstallation = site.firstData
    ? moment().diff(site.firstData * 1000, 'weeks')
    : 0;
  const meetsTCInstallRequirements = weeksSinceTCinstallation >= 2;
  const [enabled, setEnabled] = useState(meetsTCInstallRequirements);
  const { data: recordings } = useRecordingsWidgetData(
    enabled ? site.id : undefined,
    DEFAULT_SEGMENT,
    routeConfig?.name || 'activation.onboarding',
  );
  const { data: highlights } = useHighlightsList(enabled ? site.id.toString() : null, undefined, {
    itemsPerPage: 1,
    currentPage: 1,
  });

  const highlightsLink = recordings?.length
    ? getRecordingPath(recordings[0] as unknown as Recording, 'overview', null, null, {
        'highlights-flow': 'true',
      })
    : '';

  useEffect(() => {
    if (highlights && highlights.totalCount > 0) {
      setEnabled(false);
    }
  }, [highlights, setEnabled]);

  return {
    highlightsLink,
    isEnabled:
      meetsTCInstallRequirements &&
      !!recordings &&
      recordings.length >= 3 &&
      !!highlights &&
      highlights.totalCount === 0,
  };
};
